// extracted by mini-css-extract-plugin
export default {"sectionContainer":"stoniTenis_sectionContainer__QJ8WV"};